import React, { Component } from "react";
import { BlockPicker, ChromePicker, ColorResult } from "react-color";
import InputColor, { Color } from "react-input-color";
import ISupplierModel from "../../../../models/ISupplierModel";
import "./OwThemeConfigurator.scss";
import ISupplierSettings from "../../../../models/ISupplierSettings";
import IThemeVariables from "../../../../models/IThemeVariables";
import * as _ from "lodash-es";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";

type Props = {
    supplierModel: ISupplierModel;
    themeChangesFn: (mode: "LIGHT" | "DARK", theme: IThemeVariables, previewMode: boolean) => void;
    mode: "LIGHT" | "DARK";
};

type State = {
    themeDetails: IThemeVariables;
};

export default class OwThemeConfigurator extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let settings: ISupplierSettings;

        if (!_.isString(this.props.supplierModel.settings)) {
            settings = this.props.supplierModel.settings || {};
        } else {
            settings = JSON.parse(this.props.supplierModel.settings);
        }

        const themeType = this.props.mode === "DARK" ? "custom_dark" : "custom_light";

        // @ts-expect-error
        const themeDetails: IThemeVariables = settings.theme[themeType] || this.getDefaultDarkTheme();

        this.state = {
            themeDetails,
        };
    }

    getDefaultLightTheme = (): IThemeVariables => {
        return {
            mainBgColor: "#F6F4F3",
            secondaryBgColor: "#FFFFFF",
            minorBgColor: "#9DA9A0",
            centerViewBgColor: "#F6F4F3",
            mainTextColor: "#212121",
            highlightColor: "#333333",
            highlightColorText: "#FFFFFF",
            trackerHighlightColor: "#F89938",
            tabPanelBg: "#D7D5D9",
            tableOddRows: "#D7D5D9",
            tableEvenRows: "#FFFFFF",
            tableHighlightRow: "#D0CCD0",
            tableHoverRow: "#EDF6FF",
        };
    };

    getDefaultDarkTheme = (): IThemeVariables => {
        return {
            mainBgColor: "#313439",
            highlightColorText: "#212529",
            highlightColor: "#ea963c",
            centerViewBgColor: "#282b30",
            mainTextColor: "#dddddd",
            minorBgColor: "#44464a",
            secondaryBgColor: "#363b41",
            tableEvenRows: "#272b2f",
            tableHighlightRow: "#111111",
            tableHoverRow: "#222222",
            tableOddRows: "#303438",
            tabPanelBg: "#000000",
            trackerHighlightColor: "#ea963c",
        };
    };

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    updateTheme = () => {
        console.log("updateTheme");
        this.props.themeChangesFn(this.props.mode, this.state.themeDetails, false);
    };

    previewTheme = () => {
        console.log("previewTheme");
        this.props.themeChangesFn(this.props.mode, this.state.themeDetails, true);
    };

    resetTheme = () => {
        const themeDefault = this.props.mode === "LIGHT" ? this.getDefaultLightTheme() : this.getDefaultDarkTheme();

        this.setState({
            themeDetails: themeDefault,
        });
    };

    handleColorChange = (color: string, property: string) => {
        const themeDetails = this.state.themeDetails;

        // @ts-expect-error
        themeDetails[property] = color;
    };

    render() {
        if (!this.state.themeDetails) {
            return null;
        }

        const themeDefault = this.props.mode === "LIGHT" ? this.getDefaultLightTheme() : this.getDefaultDarkTheme();

        return (
            <div className={"OwThemeConfigurator"}>
                <div>
                    <OwButton title={"save"} fn={this.updateTheme} />
                    {/*<OwButton className={"ms-2 btn-warning"} title={'preview'} fn={this.previewTheme}/>*/}
                    <OwButton className={"ms-2 btn-danger"} title={"reset"} fn={this.resetTheme} />
                </div>
                <div>
                    <OwLabel title={"background"} noBottomMargin={true} />
                    <div>
                        <InputColor
                            initialValue={this.state.themeDetails.mainBgColor || themeDefault.mainBgColor}
                            onChange={(color: Color) => {
                                this.handleColorChange(color.hex, "mainBgColor");
                            }}
                            placement={"bottom"}
                        />
                    </div>
                </div>

                <div>
                    <OwLabel title={"secondary_background"} noBottomMargin={true} />
                    <div>
                        <InputColor
                            initialValue={this.state.themeDetails.secondaryBgColor || themeDefault.secondaryBgColor}
                            onChange={(color: Color) => {
                                this.handleColorChange(color.hex, "secondaryBgColor");
                            }}
                            placement={"bottom"}
                        />
                    </div>
                </div>

                <div>
                    <OwLabel title={"minor_background"} noBottomMargin={true} />
                    <div>
                        <InputColor
                            initialValue={this.state.themeDetails.minorBgColor || themeDefault.minorBgColor}
                            onChange={(color: Color) => {
                                this.handleColorChange(color.hex, "minorBgColor");
                            }}
                            placement={"bottom"}
                        />
                    </div>
                </div>

                <div>
                    <OwLabel title={"center_background"} noBottomMargin={true} />
                    <div>
                        <InputColor
                            initialValue={this.state.themeDetails.centerViewBgColor || themeDefault.centerViewBgColor}
                            onChange={(color: Color) => {
                                this.handleColorChange(color.hex, "centerViewBgColor");
                            }}
                            placement={"bottom"}
                        />
                    </div>
                </div>

                <div>
                    <OwLabel title={"tab_panel_background"} noBottomMargin={true} />
                    <div>
                        <InputColor
                            initialValue={this.state.themeDetails.tabPanelBg || themeDefault.tabPanelBg}
                            onChange={(color: Color) => {
                                this.handleColorChange(color.hex, "tabPanelBg");
                            }}
                            placement={"bottom"}
                        />
                    </div>
                </div>

                <div>
                    <div>
                        <OwLabel title={"table_odd_rows"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.tableOddRows || themeDefault.tableOddRows}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "tableOddRows");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"table_even_rows"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.tableEvenRows || themeDefault.tableEvenRows}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "tableEvenRows");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"table_selected_row"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.tableHighlightRow || themeDefault.tableHighlightRow}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "tableHighlightRow");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"table_hover_row"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.tableHoverRow || themeDefault.tableHoverRow}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "tableHoverRow");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <div>
                        <OwLabel title={"order_tracker_highlight"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.trackerHighlightColor || themeDefault.trackerHighlightColor}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "trackerHighlightColor");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"highlight_color"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.highlightColor || themeDefault.highlightColor}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "highlightColor");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"highlight_color_text"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.highlightColorText || themeDefault.highlightColorText}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "highlightColorText");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>

                    <div>
                        <OwLabel title={"main_text"} noBottomMargin={true} />
                        <div>
                            <InputColor
                                initialValue={this.state.themeDetails.mainTextColor || themeDefault.mainTextColor}
                                onChange={(color: Color) => {
                                    this.handleColorChange(color.hex, "mainTextColor");
                                }}
                                placement={"bottom"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
